import { EntityConfig } from 'angular-odata';

//#region ODataApi Imports
import { LeistungsprofilWebshopadressen } from './leistungsprofilwebshopadressen.entity';
//#endregion

export const LeistungsprofilWebshopadressenConfig = {
  name: "LeistungsprofilWebshopadressen",
  annotations: [],
  fields: {
    createdAt: {type: 'Edm.DateTimeOffset'},
    createdBy: {type: 'Edm.String'},
    changedAt: {type: 'Edm.DateTimeOffset'},
    changedBy: {type: 'Edm.String'},
    id: {type: 'Edm.Int32', key: true, ref: 'id', nullable: false}
  }
} as EntityConfig<LeistungsprofilWebshopadressen>;